import { FC, useRef } from "react";
import { Box } from "@otrium/core";
import { SearchState } from "react-instantsearch-core";
import { FilterGrid } from "./FilterGrid";
import { ActiveFilters } from "./ActiveFilters";

interface Props {
  onClose: () => void;
  onResetFilters: () => void;
  isFilterSticky: boolean;
  defaultPriceRange: { min: number; max: number };
  excludedFacetsList?: string[];
  keepSelectedIgnoreInActive?: { [p: string]: string[] };
  setStatePayload?: (
    payload: SearchState & { selectedCatSlug: string[] }
  ) => void;
  currentIndex: number | null;
  switchFilters: (index: number, filterName: string) => () => void;
}

const DesktopFilter: FC<Props> = ({
  onClose,
  onResetFilters,
  isFilterSticky,
  defaultPriceRange,
  excludedFacetsList,
  keepSelectedIgnoreInActive,
  setStatePayload,
  currentIndex,
  switchFilters,
}) => {
  const filtersGridRef = useRef<HTMLDivElement>(null);
  return (
    <Box bg="White" data-testid="desktop-filter" ref={filtersGridRef}>
      <Box>
        <FilterGrid
          onClose={onClose}
          excludedFacetsList={excludedFacetsList}
          currentIndex={currentIndex}
          switchFilters={switchFilters}
        />
        {!isFilterSticky && (
          <ActiveFilters
            onClose={onClose}
            onResetFilters={onResetFilters}
            defaultPriceRange={defaultPriceRange}
            excludedFacetsList={excludedFacetsList}
            keepSelectedIgnoreInActive={keepSelectedIgnoreInActive}
            setStatePayload={setStatePayload}
          />
        )}
      </Box>
    </Box>
  );
};
export { DesktopFilter };
